module.exports = __webpack_public_path__ + "img/watage_res_17.fc59bbbf.gif";